import { type OfferShippingsV1 } from '@redteclab/api/clients/bully'

export const shippingAccessorIsFreeShippingMarketplace = (
  offerDeliveryCosts: OfferShippingsV1[] | null,
): boolean => {
  if (offerDeliveryCosts === null) {
    return true
  }

  const isShippingZero = (offerDeliveryCost: OfferShippingsV1): boolean =>
    offerDeliveryCost.totalShippingPrice === 0

  const hasOfferCosts = offerDeliveryCosts.length > 0

  if (!hasOfferCosts) {
    return true
  }

  return offerDeliveryCosts.every(isShippingZero)
}
